/**
 * Cookku card ATC handler — bypass Dawn product-form.js for grid cards.
 * Uses Dawn's default section name 'cart-drawer' (overridden by our content).
 */
(function () {
  if (window.__cookkuCardAtcBound) return;
  window.__cookkuCardAtcBound = true;

  const SECTION_ID = 'cart-drawer';
  const BUBBLE_ID = 'cart-icon-bubble';
  const submittingForms = new WeakSet();

  const findDrawerHtml = (sections) => {
    if (!sections) return null;
    return sections[SECTION_ID]
      || sections[Object.keys(sections).find((k) => /(cart[-_]drawer)/i.test(k))];
  };

  const updateDrawerFromHTML = (html) => {
    if (window.cookkuCartActions && window.cookkuCartActions.updateDrawerFromHTML) {
      return window.cookkuCartActions.updateDrawerFromHTML(html);
    }
    if (!html) return false;
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const newPanel = parsed.querySelector('#CartDrawer');
    const currentPanel = document.querySelector('cart-drawer #CartDrawer');
    if (newPanel && currentPanel) {
      currentPanel.innerHTML = newPanel.innerHTML;
      return true;
    }
    return false;
  };

  const updateCartIconBubble = (html) => {
    if (window.cookkuCartActions && window.cookkuCartActions.updateCartIconBubble) {
      return window.cookkuCartActions.updateCartIconBubble(html);
    }
    if (!html) return;
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const bubbleEl = document.getElementById('cart-icon-bubble');
    if (!bubbleEl) return;
    const newSection = parsed.querySelector('.shopify-section') || parsed.body.firstElementChild;
    if (newSection) {
      bubbleEl.innerHTML = newSection.innerHTML || newSection.outerHTML;
    }
  };

  const fetchSections = (ids) => {
    const url = `${window.location.pathname}?sections=${ids.join(',')}`;
    return fetch(url, { credentials: 'same-origin' }).then((r) => r.json());
  };

  const openDrawer = () => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    drawer.classList.remove('is-empty');
    const inner = drawer.querySelector('.drawer__inner');
    inner && inner.classList.remove('is-empty');
    if (typeof drawer.open === 'function') {
      drawer.open();
    } else {
      drawer.classList.add('animate', 'active');
      document.body.classList.add('overflow-hidden');
    }
  };

  const setLoading = (button, loading) => {
    if (!button) return;
    button.disabled = loading;
    if (loading) {
      button.setAttribute('aria-busy', 'true');
      button.classList.add('loading');
      const spinner = button.querySelector('.loading__spinner');
      spinner && spinner.classList.remove('hidden');
    } else {
      button.removeAttribute('aria-busy');
      button.classList.remove('loading');
      const spinner = button.querySelector('.loading__spinner');
      spinner && spinner.classList.add('hidden');
    }
  };

  document.addEventListener(
    'submit',
    function (event) {
      const form = event.target;
      if (!form || form.tagName !== 'FORM') return;

      const productForm = form.closest('product-form[data-cookku-card-atc]');
      if (!productForm) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      if (submittingForms.has(form)) return;

      const formData = new FormData(form);
      formData.append('sections', `${SECTION_ID},${BUBBLE_ID}`);
      formData.append('sections_url', window.location.pathname);
      submittingForms.add(form);

      const submitBtn = form.querySelector('[type="submit"]');
      setLoading(submitBtn, true);
      let itemAdded = false;

      fetch(window.routes ? window.routes.cart_add_url : '/cart/add.js', {
        method: 'POST',
        headers: {
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData,
        credentials: 'same-origin'
      })
        .then((res) => res.json())
        .then((response) => {
          if (response.status) {
            console.error('[Cookku ATC] error:', response.description || response.message);
            form.dispatchEvent(new CustomEvent('cookku:card-add-error', { bubbles: true, detail: { message: response.description || response.message } }));
            return;
          }
          itemAdded = true;
          form.dispatchEvent(new CustomEvent('cookku:card-added', { bubbles: true }));

          const sectionsFromAdd = response.sections || {};
          const drawerHtml = findDrawerHtml(sectionsFromAdd);
          let drawerOk = false;
          if (drawerHtml) {
            drawerOk = updateDrawerFromHTML(drawerHtml);
          }
          if (sectionsFromAdd[BUBBLE_ID]) {
            updateCartIconBubble(sectionsFromAdd[BUBBLE_ID]);
          }

          if (drawerOk) {
            openDrawer();
            return;
          }

          /* Fallback: fetch sections via Section Rendering API */
          return fetchSections([SECTION_ID, BUBBLE_ID]).then((sections) => {
            const drawerUpdated = updateDrawerFromHTML(findDrawerHtml(sections));
            if (!drawerUpdated) throw new Error('Cart drawer refresh returned no valid markup');
            updateCartIconBubble(sections[BUBBLE_ID]);
            openDrawer();
          });
        })
        .catch((err) => {
          console.error('[Cookku ATC] fetch error:', err);
          if (itemAdded) {
            window.location.assign(window.routes?.cart_url || '/cart');
            return;
          }
          form.dispatchEvent(new CustomEvent('cookku:card-add-error', { bubbles: true, detail: { message: 'Could not add this item. Please try again.' } }));
        })
        .finally(() => {
          submittingForms.delete(form);
          setLoading(submitBtn, false);
        });
    },
    true
  );
})();
